import { Link } from "react-router-dom";
import PageLayout from "@/components/feature/PageLayout";
import { newsItems } from "@/mocks/news";

export default function NewsPage() {
  return (
    <PageLayout>
      {/* Hero */}
      <div className="relative py-14 md:py-20 bg-primary-700 overflow-hidden">
        <div className="absolute inset-0 opacity-15">
          <img
            src="https://readdy.ai/api/search-image?query=Clean%20modern%20office%20interior%20with%20minimal%20desk%20and%20subtle%20warm%20lighting%2C%20soft%20professional%20atmosphere%2C%20abstract%20blurred%20background%20with%20gentle%20gradient%2C%20corporate%20Japanese%20aesthetic%2C%20serene%20and%20composed&width=1600&height=600&seq=news-hero&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20" />
        <div className="relative z-10 w-full px-4 md:px-8">
          <div className="max-w-4xl mx-auto">
            <nav className="mb-4">
              <ol className="flex items-center gap-2 text-sm text-background-300">
                <li>
                  <Link to="/" className="hover:text-background-100 transition-colors">
                    ホーム
                  </Link>
                </li>
                <li>
                  <i className="ri-arrow-right-s-line text-xs" />
                </li>
                <li className="text-background-100">お知らせ</li>
              </ol>
            </nav>
            <h1 className="text-3xl md:text-4xl font-black text-background-50">
              お知らせ
            </h1>
            <p className="text-accent-300 text-sm mt-2">News &amp; Announcements</p>
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-4xl mx-auto">
          {/* News List */}
          <div className="space-y-3">
            {newsItems.map((item, i) => {
              const isExternal = !!item.href;
              const linkProps = isExternal
                ? { href: item.href, target: "_blank", rel: "noopener noreferrer" }
                : { to: item.to || "/" };
              const Wrapper = isExternal ? "a" : Link;

              return (
                <Wrapper
                  key={i}
                  {...linkProps}
                  className="group flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 md:gap-6 px-4 sm:px-5 py-4 rounded-xl bg-background-50 border border-background-200/40 hover:border-primary-300 transition-all duration-200"
                >
                  {/* Row 1 (mobile) / inline (desktop): date, category + NEW, arrow */}
                  <div className="flex items-center gap-2 sm:gap-4 md:gap-6 sm:shrink-0">
                    <time className="text-xs text-foreground-500 sm:w-[72px] sm:text-right font-mono whitespace-nowrap">
                      {item.date}
                    </time>
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                      {item.category}
                      {item.isNew && (
                        <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-primary-500 text-background-50 text-[10px] font-bold">
                          NEW
                        </span>
                      )}
                    </span>
                    {/* Arrow — visible only on mobile, pushed to right */}
                    <i
                      className={`${
                        isExternal ? "ri-external-link-line" : "ri-arrow-right-line"
                      } text-foreground-400 text-sm sm:hidden ml-auto`}
                    />
                  </div>

                  {/* Row 2 (mobile) / inline (desktop): title */}
                  <div className="flex items-center gap-2 flex-1 min-w-0">
                    <span className="text-sm text-foreground-700 group-hover:text-foreground-900 transition-colors line-clamp-2 sm:line-clamp-1 leading-relaxed">
                      {item.label}
                    </span>
                  </div>

                  {/* Arrow — desktop only */}
                  <i
                    className={`hidden sm:block ${
                      isExternal ? "ri-external-link-line" : "ri-arrow-right-line"
                    } text-foreground-400 text-sm flex-shrink-0 group-hover:text-primary-500 transition-colors`}
                  />
                </Wrapper>
              );
            })}
          </div>
        </div>
      </div>
    </PageLayout>
  );
}